import React from "react"

export default function Skeleton(props: any) {
    return (
        <div className={"skeleton"}>
            {props.children}
        </div>
    )
};